
import React, { Fragment } from 'react';

import "./index.scss";

const dayTable = [
    'Sun',
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat',
];

const monthTable = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

const timescrollerTimes = [
    { key: '0000', value: 'Midnight' },
    { key: '0430', value: 'Early morning' },
    { key: '0900', value: 'Morning' },
    { key: '1200', value: 'Noon' },
    { key: '1530', value: 'Afternoon' },
    { key: '1700', value: 'Evening' },
    { key: '1930', value: 'Late evening' },
    { key: '2100', value: 'Night' },
    { key: '2230', value: 'Late night' },
];

const timescrollerTimeLookup = new Map(
    timescrollerTimes.map((item, index) => [item.key, index]));

// // Generate fake stable rows for early dev
// const timeData = [];
// let hh = 0;
// let mm = 0;
// let ss = 0;
// for (let fake = 0; fake < 96; ++fake) {
//     ss = Math.floor(Math.random() * 2);
//     const fakeTime = hh * 10000 + mm * 100 + ss;
//     const fakeTimeText = ('' + fakeTime).padStart(6, '0');
//     const displayedTime = [
//         fakeTimeText.slice(0, 2),
//         fakeTimeText.slice(2, 4),
//         fakeTimeText.slice(4, 6)
//     ].join(':');
//     timeData.push({
//         key: displayedTime, 
//         value: 'fakeurl'
//     });
//     if ((mm += 15) >= 60) {
//         mm -= 60;
//         hh += 1;
//     }
// }

const dayOptionsTo31 = Array.from({length: 31}).map((_, i) => {
    const dayStr = '' + (i + 1);
    return <option key={dayStr}
        value={dayStr}
        children={dayStr}/>;
})

function debugFetch(url, options) {
    if (url.startsWith('/api/cam')) {
        if (''.includes('/access?')) {

        } else {

        }
    }
}

// 


export default class Camera extends React.Component {
    constructor(props) {
        super(props);

        console.log('Camera component deviceId', props.deviceId, 
            'before toLowerCase');

        // Local midnight
        const localMidnight = new Date();
        localMidnight.setHours(0, 0, 0, 0);

        const minDate = new Date(localMidnight.getTime());
        minDate.setDate(minDate.getDate() - 364);

        this.state = {
            /** @type {boolean | null} */
            cameraExists: null,

            //
            // Date
            /** @type {string} */
            macaddr: this.macaddrFromDeviceId(props.deviceId),

            /** 
             * Null selected date means today
             * @type {Date | null}
             */
            selectedDate: null,

            /** @type {Date} */
            minDate: minDate,

            /** @type {Date} */
            today: localMidnight,

            //
            // Time

            /** @type {number} */
            timeIndex: 0,

            /** 
             * When the user navigates to a time, it
             * becomes the "desired time", which is
             * sought when you change the date,
             * to prime timeIndex
             * @type {string}
             */
            desiredTimeOfDay: '000000',

            /**
             * key on yyyymmdd, value are
             * objects keyed on hhmmss, values are urls
             * @type {Map<string, string> | null}
             */
            dateLookup: null,

            /** 
             * Populated with images from the selected date
             * @type {Array<{key: string, value: string}> | null}
             */
            timeList: null,

            /**
             * This is captured from the first response
             * This is to avoid having to redundantly give
             * the common prefix on all the signed urls
             * @type {string}
             */
            urlPrefix: '',

            /**
             * Used by the Toast component to hold toast messages
             * @type {Map<number, unknown>}
             */
            messages: new Map(),

            /**
             * Holds the local midnight timestamp for each day 
             * whose image list did not load
             * @type {Set<number>}
             */
            failed: new Set()
        };

        this._messageExpirer = Toast.makeRemover(this, 'messages');

        this._midnightTimer = null;
    }
    
    _mounted = false;
    
    componentDidMount() {
        this._mounted = true;
        console.log('mounting camera component');
        this._scheduleNextMidnight();

        const loadedDate = new Date(this.state.today.getTime());
        this.changeDate(loadedDate)
        .then((exists) => {
            this.setState({
                initialLoading: false,
                cameraExists: exists
            });
        }).catch((err) => {
            this.setState({
                cameraExists: false
            })
        });
    }

    componentDidUpdate(prevProps, prevState) {
        console.log('component did update');

        if (prevState.selectedDate !== this.state.selectedDate)
            this.changeDate(this.state.selectedDate || this.state.today);
    }

    macaddrFromDeviceId(deviceId) {
        return deviceId.toLowerCase().split(':', 1)[0];
    }

    changeDate(loadedDate) {
        return this.loadDate(loadedDate)
        .then((day) => {
            if (!day)
                return false;

            console.log('loaded', day);
            const { timestamps, urls } = day;
            const timestampsLength = timestamps.length;
            const urlsLength = urls.length;
            console.assert(timestampsLength === urlsLength, 
                'Array length mismatch');
            // Generate timeList
            const newTimeList = [];
            for (let i = 0; i < timestamps.length; ++i) {
                const date = new Date(timestamps[i]);
                const url = urls[i];
                const hh = String(date.getHours()).padStart(2, '0');
                const mm = String(date.getMinutes()).padStart(2, '0');
                const ss = String(date.getSeconds()).padStart(2, '0');
                const hhmmss = `${hh}${mm}${ss}`;
                newTimeList.push({
                    key: hhmmss,
                    value: url
                });
            }
            this.setState({
                timeList: newTimeList
            });
            return true;
        })
        .catch((err) => {
            console.log(err.stack);
            this.setState({
                timeList: null
            });
            if (err.message.toLowerCase().includes('not found'))
                return null;

            return false;
        });
    }

    setDateFailed(loadedDate) {
        return this.setDateSucceeded(loadedDate, false);
    }

    setDateSucceeded(loadedDate, succeeded = true) {
        if (!this._mounted)
            return;
        this.setState((prevState) => {
            const newFailed = new Set(prevState.failed);
            
            if (succeeded)
                newFailed.delete(loadedDate.getTime());
            else
                newFailed.add(loadedDate.getTime());

            return {
                failed: newFailed
            };
        });
    }

    loadDate(midnight) {
        // Local midnight
        const iter = new Date(midnight.getTime());
        // Local next midnight
        const nextMidnight = new Date(midnight.getTime());
        nextMidnight.setDate(nextMidnight.getDate() + 1);

        // Get raw timestamps for the local day span
        const stTs = iter.getTime();
        const enTs = nextMidnight.getTime();

        const utcMidnights = [];
        const promises = [];

        // Round down to start of intersecting UTC day
        iter.setUTCHours(0, 0, 0, 0);
        utcMidnights.push(new Date(iter.getTime()));

        // Get first day
        promises.push(this.getDayFromUTCMidnightAsync(
            new Date(iter.getTime())));

        // While we need more days, get the days
        for (;;) {
            // Advanced to next UTC midnight
            iter.setUTCDate(iter.getUTCDate() + 1);
            if (iter.getTime() >= enTs)
                break;
            utcMidnights.push(new Date(iter.getTime()));
            // Fetch that day
            promises.push(this.getDayFromUTCMidnightAsync(
                new Date(iter.getTime())));
        }

        return Promise.all(promises)
        .then((bodies) => {
            let utcDayIndex = -1;
            const timestamps = [];
            const urls = [];
            
            for (const body of bodies) {
                ++utcDayIndex;

                const bodyMidnight = utcMidnights[utcDayIndex];
                const bodyYear = bodyMidnight.getUTCFullYear();
                const bodyMonth = bodyMidnight.getUTCMonth();
                const bodyDay = bodyMidnight.getUTCDate();

                const timeKeys = Object.keys(body);
                const imageUrls = Object.values(body);

                let utcTimeIndex = -1;
                for (const time of timeKeys) {
                    ++utcTimeIndex;
                    const hh = +time.slice(0, 2);
                    const mm = +time.slice(2, 4);
                    const ss = +time.slice(4, 6);
                    const timestamp = Date.UTC(
                        bodyYear, bodyMonth, bodyDay,
                        hh, mm, ss);
                    if (timestamp >= stTs && timestamp < enTs) {
                        timestamps.push(timestamp);
                        urls.push(imageUrls[utcTimeIndex]);
                    }
                }
            }

            this.setDateSucceeded(midnight);

            console.assert(timestamps.length === urls.length);
            for (let i = 1; i < timestamps.length; ++i) {
                if (timestamps[i] <= timestamps[i-1])
                    throw new Error("Timestamps out of order!");
            }

            //
            return {
                timestamps,
                urls
            };
        }).catch((err) => {
            console.log(`Failed to load images` +
                    ` for ${midnight.toDateString()}:` +
                    (err.message));
            Toast.addToastToStateOf(this, {
                content: `Failed to load images` +
                    ` for ${midnight.toDateString()}`
            });
            this.setDateFailed(midnight);
            return null;
        });
    }

    _ws = null;

    // UTC keyed by timestamp (UTC midnights)
    // value is promise resoloving to a TimeMap 
    // (each property name is "hhmmss", their value is "url")
    _dayCache = new Map();
    _dayCacheLimit = 128;

    getDayFromUTCMidnightAsync(date) {
        if (date.getUTCHours() !== 0 ||
            date.getUTCMinutes() !== 0 ||
            date.getUTCSeconds() !== 0 ||
            date.getUTCMilliseconds() !== 0
        ) {
            throw new Error('Date must be aligned to UTC midnight');
        }

        const timestamp = date.getTime();

        // Fastpath
        let promise = this._dayCache.get(timestamp);
        if (promise)
            return promise;

        // Slow path (cache miss)
        const nextDay = new Date(timestamp);
        nextDay.setUTCDate(nextDay.getUTCDate() + 1);

        const yyyySt = date.getUTCFullYear();
        const yyyyEn = nextDay.getUTCFullYear();
        const mmSt = date.getUTCMonth() + 1;
        const mmEn = nextDay.getUTCMonth() + 1;
        const ddSt = date.getUTCDate();
        const ddEn = nextDay.getUTCDate();
        const pad = (n) => String(n).padStart(2, '0');
        const yyyymmddSt = `${yyyySt}${pad(mmSt)}${pad(ddSt)}`;
        const yyyymmddEn = `${yyyyEn}${pad(mmEn)}${pad(ddEn)}`;

        // Fetch one complete UTC day
        promise = this.fetchDayAsync(yyyymmddSt, yyyymmddEn);

        // Notice that we don't swallow the error,
        // this is a branch off the returned chain.
        // We evict erroneous cache entries, requesting
        // that day again will repeat the failed request
        promise.catch((err) => {
            console.log('day fetch error:', err);
            this._dayCache.delete(timestamp);
        });

        // Cap the cache size - drop the oldest entry
        if (this._dayCache.size >= this._dayCacheLimit) {
            const oldestKey = this._dayCache.keys().next().value;
            this._dayCache.delete(oldestKey);
        }

        this._dayCache.set(timestamp, promise);

        return promise;
    }

    fetchDayAsync(from, to) {
        return this.request(`/api/cam/${this.state.macaddr}/days` +
            `?from=${encodeURIComponent(from)}` +
            `&to=${encodeURIComponent(to)}`)
        .then((body) => {
            if (this.state.prefix !== body.prefix) {
                this.setState({
                    urlPrefix: body.prefix
                });
            }
            const days = body.days;
            const entries = Object.entries(days);
            if (entries.length === 1) {
                // It found one, return the timeMap at the 0th date
                return entries[0][1];
            } else if (entries.length === 0) {
                // It found none, return empty timeMap
                return {};
            } else {
                // This can't happen
                throw new Error(`Unexpected number of` +
                    ` day entries: ${entries.length}`);
            }
        });
    }

    request(url) {
        const token = localStorage.getItem('auth_token');

        return fetch(url, {
            headers: {
                authorization: token
            }
        })
        .then((response) => {
            if (!response.ok) {
                const statusCode = response.status;
                return Promise.reject(
                    new Error(`HTTP status ${statusCode}`));
            }

            const contentTypeHeader =
                response.headers.get('content-type') || '';

            const [
                contentType
            ] = contentTypeHeader.split(';', 1);

            if (contentType === 'application/json')
                return response.json();

            if (contentType === 'text/plain')
                return response.text();

            return response.blob();
        });
    }

    componentWillUnmount() {
        console.log('unmounted camera component');
        if (this._midnightTimer)
            clearTimeout(this._midnightTimer);
        this._midnightTimer = null;
        this._mounted = false;
    }

    _scheduleNextMidnight = () => {
        if (this._midnightTimer)
            clearTimeout(this._midnightTimer);

        const now = new Date();
        const nextMidnight = new Date(now);
        nextMidnight.setHours(24, 0, 0, 0);
        const ms = nextMidnight.getTime() - now.getTime();

        this._midnightTimer = setTimeout(() => {
            const d = new Date();
            d.setHours(0, 0, 0, 0);

            const minDate = new Date(d.getTime());
            // We only subtract 364 because today is
            // not properly after the last day
            // (it is the morning of the last day)
            minDate.setDate(minDate.getDate() - 364);

            this.setState({
                today: d,
                minDate: minDate
            }, () => {
                // reschedule again for the next day
                this._scheduleNextMidnight();
            });
        }, ms);
    };

    _setSelectedDate = (newDateOrNull) => {
        // if (newDateOrNull)
        //     newDateOrNull = new Date(+newDateOrNull);
        if (!newDateOrNull && !this.state.selectedDate)
            return;
        if (newDateOrNull && this.state.selectedDate &&
            +newDateOrNull === +this.state.selectedDate)
            return;
        console.log('selectedDate', newDateOrNull);
        // "Today" is null - it follows the today of "now"
        if (newDateOrNull &&
            newDateOrNull.getTime() >= this.state.today.getTime())
            newDateOrNull = null;
        this.setState({
            selectedDate: newDateOrNull
        });
    };

    _adjustSelectedDate = (adjMonth, adjDay, adjHour, adjPic) => {
        let newDate = new Date(this.state.selectedDate || this.state.today)
        if (adjMonth) {
            newDate.setMonth(newDate.getMonth() + adjMonth);
            if (newDate.getTime() > this.state.today.getTime())
                newDate.setTime(this.state.today.getTime());
            if (newDate.getTime() < this.state.minDate.getTime())
                newDate.setTime(this.state.minDate.getTime());
        }
        if (adjDay)
            newDate.setDate(newDate.getDate() + adjDay);
        if (newDate.getTime() >= this.state.today.getTime())
            newDate = null;
        this._setSelectedDate(newDate);

        if (adjPic) {
            this.setTimeIndex(this.state.timeIndex + adjPic);
            // this.setState({
            //     timeIndex: this.state.timeIndex + adjPic
            // });
        }
    };

    _timeToDaySec(time) {
        const hht = time.slice(0, 2);
        const mmt = time.slice(2, 4);
        const sst = time.slice(4, 6);
        const hh = +hht;
        const mm = +mmt;
        const ss = +sst;
        const daySec = hh * 3600 + mm * 60 + ss;
        return daySec;
    }

    _findNearestTimeIndex(time) {
        const targetSec = this._timeToDaySec(time);
        let match = -1;
        let matchErr = 0;
        let i;
        const { timeList } = this.state;
        const end = (timeList || []).length;
        for (i = 0; i < end; ++i) {
            const timeEnt = timeList[i];
            const daySec = this._timeToDaySec(timeEnt.key);
            const err = daySec - targetSec;
            if (match < 0 || Math.abs(err) < Math.abs(matchErr)) {
                match = i;
                matchErr = err;
            }
            // Stop searching when it is only getting worse
            if (err > 0)
                break;
        }
        return match;
    }

    _timescrollerScrollRef = React.createRef();
    // The scroller links
    _timescrollerRefs = [];
    // Just the rows that have scroller link to it
    _timeEdgeRefs = [];
    // Every row
    _timeRefs = [];
    _imageViewerRef = React.createRef();

    _messageExpirer = null;

    render() {
        console.log('Rendering camera tab');

        if (this.state.cameraExists === null) {
            return <Fragment>Loading...</Fragment>;
        } else if (this.state.cameraExists === false) {
            return <Fragment>Camera not detected</Fragment>;
        }

        const weekRows = [];

        const todayTime = this.state.today.getTime();

        const today = this.state.today;

        const base = this.state.selectedDate || this.state.today;

        // Copy selected date
        const end = new Date(base.getTime());
        // Set to 1st
        end.setDate(1);
        // Advance to next month
        end.setMonth(end.getMonth() + 1);
        // Bump back to last day of selected month
        end.setDate(0);
        // Align to start of week
        end.setDate((end.getDate() - end.getDay()) + 14);

        // Start at the selected date
        const dateIt = new Date(base.getTime());

        // Jump to the 1st of that month
        dateIt.setDate(1);

        // Find what day of the week it is
        const dayOfWeekOf1st = dateIt.getDay();

        // Rewind to first row's sunday
        dateIt.setDate(1 - dayOfWeekOf1st - 7);

        while (dateIt.getTime() < end.getTime()) {
            const days = Array.from({length: 7}).map((_, i) => {
                const baseTime = base.getTime();
                const weekStart = dateIt.getTime();
                const date = new Date(weekStart);
                date.setDate(date.getDate() + i);
                const isThisMonth = date.getMonth() === base.getMonth();
                const isSelectedDay = date.getTime() === baseTime;
                const dow = date.getDay();
                const isWeekend = dow < 1 || dow > 5;
                const isFuture = date.getTime() > todayTime;
                const isAncient = date.getTime() <
                    this.state.minDate.getTime();
                const isOob = isFuture || isAncient;
                const isFailed = this.state.failed.has(date.getTime());

                return <td key={date.getTime()}
                    className={'calendar-day' +
                        (isThisMonth ? ' this-month' : ' other-month') +
                        (isWeekend ? ' calendar-weekend' : ' calendar-weekday') +
                        (isSelectedDay ? ' selected' : '') +
                        (isOob ? ' calendar-oob' : '') +
                        (isFailed ? ' calendar-failed' : '')}
                    onClick={(event) => {
                        event.preventDefault();
                        if (!isOob)
                            this._setSelectedDate(date);
                    }}
                >
                    {date.getDate()}
                </td>;
            });
            weekRows.push(<tr className="calendar-week-row"
                key={dateIt.getTime()}
                children={days}/>);
            dateIt.setDate(dateIt.getDate() + 7);
        }

        const todaySelected = base.getTime() ===
            this.state.today.getTime();
        const minDateSelected = base.getTime() ===
            this.state.minDate.getTime();

        const dayCountDate = new Date(base.getTime());
        dayCountDate.setDate(1);
        dayCountDate.setMonth(dayCountDate.getMonth() + 1);
        dayCountDate.setDate(0);
        const daysInMonth = dayCountDate.getDate();
        const dayOptions = dayOptionsTo31.slice(0, daysInMonth);

        const monthGroups = [[], []];

        // Put the months into optgroups indicating which year they are
        monthTable.forEach((monthName, monthIndex) => {
            const isPrevYear = (monthIndex > this.state.today.getMonth());
            monthGroups[+isPrevYear].push(<option
                key={monthName}
                value={'' + monthIndex}
                children={monthName}/>);
        });

        const thisYear = today.getFullYear();
        const lastYear = thisYear - 1;

        const thisYearText = '' + thisYear;
        const lastYearText = '' + lastYear;

        const monthOptGroups = [
            <optgroup label={thisYearText}
                key={thisYearText}
                children={monthGroups[0]} />,
            <optgroup label={lastYearText}
                key={lastYearText}
                children={monthGroups[1]} />
        ];

        if (monthGroups[0].length === 0)
            monthOptGroups.shift();
        if (monthGroups[monthGroups.length-1].length === 0)
            monthOptGroups.pop();

        // Year
        const yearOptions = [];

        if (base.getMonth() >= today.getMonth()) {
            yearOptions.push(<option
                key={'lastyear'}
                value={lastYearText}
                children={lastYearText}
                />
            );
        }

        if (base.getMonth() <= today.getMonth()) {
            yearOptions.push(<option
                key={'thisyear'}
                value={thisYearText}
                children={thisYearText}
                />
            );
        }

        const monthsAgo = (today.getFullYear() * 12 + today.getMonth()) -
            (base.getFullYear() * 12 + base.getMonth());
        const daysAgo = Math.floor((today.getTime() -
            base.getTime()) / 86400e3);

        let dateDescription = (daysAgo > 30 && monthsAgo > 0)
            ? `${monthsAgo} month${monthsAgo>1?'s':''} ago`
            : daysAgo
            ? `${daysAgo} day${daysAgo>1?'s':''} ago`
            : `Today`;

        if (dateDescription === '1 day ago')
            dateDescription = 'Yesterday';

        const dayNameCells = dayTable.map((dayName) => {
            return <td className="calendar-day-name" key={dayName}
                children={dayName}/>;
        });

        const monthSelect = <select children={monthOptGroups}
            value={'' + base.getMonth()}
            onChange={(event) => {
                const newDate = new Date(base.getTime());
                newDate.setMonth(+event.target.value);
                this._wrapClampAndSetSelectedDate(newDate);
            }}
            />;

        const daySelect = <select children={dayOptions}
            value={'' + base.getDate()}
            onChange={(event) => {
                const newDate = new Date(base.getTime());
                newDate.setDate(+event.target.value);
                // If they go after today,
                // they must mean almost a year ago
                if (newDate.getTime() > this.state.today.getTime())
                    newDate.setFullYear(this.state.minDate.getFullYear());
                // If they go before the beginning,
                // they must mean near the end
                if (newDate.getTime() < this.state.minDate.getTime())
                    newDate.setFullYear(this.state.today.getFullYear());
                // Clamp to inside range
                if (newDate.getTime() < this.state.minDate.getTime())
                    newDate.setTime(this.state.minDate.getTime());
                if (newDate.getTime() > this.state.today.getTime())
                    newDate.setTime(this.state.today.getTime());
                this._setSelectedDate(newDate);
            }}
        />;

        const yearSelect = <select children={yearOptions}
            value={'' + base.getFullYear()}
            onChange={(event) => {
                const newDate = new Date(base.getTime());
                newDate.setFullYear(+event.target.value);
                if (newDate.getTime() <
                    this.state.minDate.getTime())
                    newDate.setTime(this.state.minDate.getTime());
                else if (newDate.getTime() >
                    this.state.today.getTime())
                    newDate.setTime(this.state.today.getTime());
                this._setSelectedDate(newDate);
            }}
        />;

        const datePicker = <div
            className="datepicker-container inline-container"
        >
            <table>
                <tbody>
                    <tr className="calendar-date-row">
                        <td>
                            <button className="btn-sm calendar-day-button"
                                disabled={minDateSelected}
                                onClick={(event) => {
                                    event.preventDefault();
                                    this._adjustSelectedDate(-1, 0, 0, 0);
                                }}
                            >
                                ◀◀ M
                            </button>
                        </td>
                        <td>
                            <button className="btn-sm calendar-day-button"
                                disabled={minDateSelected}
                                onClick={(event) => {
                                    event.preventDefault();
                                    this._adjustSelectedDate(0, -1, 0, 0);
                                }}
                            >
                                ◀ D
                            </button>
                        </td>
                        <td colSpan={3}>
                            &nbsp;
                        </td>
                        <td>
                            <button className="btn-sm calendar-day-button"
                                disabled={todaySelected}
                                onClick={(event) => {
                                    event.preventDefault();
                                    this._adjustSelectedDate(0, 1, 0, 0);
                                }}
                            >
                                ▶ D
                            </button>
                        </td>
                        <td>
                            <button className="btn-sm calendar-day-button"
                                disabled={todaySelected}
                                onClick={(event) => {
                                    event.preventDefault();
                                    this._adjustSelectedDate(1, 0, 0, 0);
                                }}
                            >
                                ▶▶ M
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table>
                <tbody>
                    <tr>
                        <td colSpan={12} className="date-description">
                            {dateDescription}
                        </td>
                    </tr>
                    <tr>
                        <td className="calendar-date" colSpan={7}>
                            {monthSelect}
                            {daySelect}
                            {yearSelect}
                        </td>
                    </tr>
                    <tr children={dayNameCells}/>
                    {weekRows}
                </tbody>
            </table>
        </div>;

        const datepickerContainer =
        <div className="datepicker-container inline-container">
            <table className="datepicker-table">
                <tbody>
                    <tr>
                        <td colSpan={7} children={datePicker}/>
                    </tr>
                </tbody>
            </table>
        </div>;

        const timeListLen = this.state.timeList &&
            this.state.timeList.length || 0;

        // These are copied from the full edge ref array
        while (this._timeEdgeRefs.length < timescrollerTimes.length)
            this._timeEdgeRefs.push(null);

        while (this._timescrollerRefs.length < timescrollerTimes.length)
            this._timescrollerRefs.push(React.createRef());

        while (this._timeRefs.length < timeListLen)
            this._timeRefs.push(React.createRef());
        while (this._timeRefs.length > timeListLen)
            this._timeRefs.pop();

        const timeRows = this.state.timeList &&
            this.state.timeList.map(({key: time, value: url}, index) => {
            const timeKey = time.replace(/:/g, '').slice(0, 4);
            let refIndex = timescrollerTimeLookup.get(timeKey);
            if (refIndex === undefined)
                refIndex = -1;
            // console.log('time', time, 'resolved to',
            //     timeKey, 'and looked up', refIndex);

            // Copy the time ref to the time edge ref
            if (refIndex >= 0)
                this._timeEdgeRefs[refIndex] = this._timeRefs[index];

            const ref = this._timeRefs[index];
            const isSelected = this.state.timeIndex === index;
            return <tr className="timepicker-row"
                key={time}
            >
                <td ref={ref}
                    className={"timepicker-time" +
                        (this.state.timeIndex === index
                        ? ' selected' : '')
                    }
                    role="option"
                    tabIndex={isSelected ? 0 : -1}
                    aria-selected={isSelected}
                    onClick={(event) => {
                        this.setState({
                            timeIndex: index
                        });
                    }}
                    onKeyDown={(event) => {
                        let next = null;

                        if (event.key === 'ArrowDown') {
                            event.preventDefault();
                            if (this.state.timeList) {
                                next = Math.min(index + 1,
                                    this.state.timeList.length - 1);
                            }
                        } else if (event.key === 'ArrowUp') {
                            event.preventDefault();
                            next = Math.max(0, index - 1);
                        } else if (event.key === 'Home') {
                            event.preventDefault();
                            next = 0;
                        } else if (event.key === 'End') {
                            event.preventDefault();
                            if (this.state.timeList)
                                next = this.state.timeList.length - 1;
                        } else if (event.key === 'Enter' || 
                            event.key === ' '
                        ) {
                            event.preventDefault();
                            // this.setState({
                            //     timeIndex: index
                            // }, () => {
                            //     this._timeRefs[index] &&
                            //         this._timeRefs[index].scrollIntoView();
                            // });
                            return;
                        } else {
                            console.log('ignoring keypress:', event.key);
                            return;
                        }

                        const el = this._timeRefs[next] &&
                            this._timeRefs[next].current;
                        if (el) {
                            // el.click();
                            this.setTimeIndex(next);
                            // el.scrollInfoView({
                            //     behavior: "smooth",
                            //     block: "nearest"
                            // });
                        }

                        // event.preventDefault();
                        // this.setState({
                        //     timeIndex: next
                        // }, () => {

                        // });
                    }}
                >
                    <span className="noto">
                        📸
                    </span>
                    &nbsp;{time}
                </td>
            </tr>;
        });

        // console.log('timescroller refs', this._timescrollerRefs);

        // This element scrolls its children
        const timepickerContainer =
        <div className="timepicker-container inline-container"
            ref={this._timescrollerScrollRef}
        >
            <table className="timepicker-table">
                <tbody children={timeRows}/>
            </table>
        </div>;

        const { timescrollerHighlightIndex } = this.state;

        const timescrollerButtons = timescrollerTimes.map((info, index) => {
            return <a
                ref={this._timescrollerRefs[index]}
                href='#'
                key={info.key}
                onClick={(event) => {
                    event.preventDefault();
                    const newTimeIndex = 
                        timescrollerTimeLookup.get(info.key);
                    if (newTimeIndex !== undefined)
                        this.setTimeIndex(newTimeIndex, this._timeEdgeRefs);
                }}
                className={timescrollerHighlightIndex === index
                    ? ' selected' : ''}
            >
                {info.value} ({insertColons(info.key)})
            </a>
        });

        const timescrollerContainer =
        <div className="timescroller-container inline-container">
            {timescrollerButtons}
        </div>;

        const currentImage = this.state.timeList &&
            this.state.timeList[this.state.timeIndex] &&
            this.state.timeList[this.state.timeIndex].value &&
            (this.state.urlPrefix + 
            this.state.timeList[this.state.timeIndex].value) ||
            null;
        
        const firstPic = this.state.timeIndex === 0;
        const lastPic = this.state.timeList ?
             this.state.timeIndex + 1 === this.state.timeList.length
             : true;

        return <Fragment>
            <Toast messages={this.state.messages}
                onExpire={this._messageExpirer}/>
            <div className="datetimepicker-container">
                {datepickerContainer}
                {timepickerContainer}
                {timescrollerContainer}
            </div>
            <div className="image-controls">
                <button onClick={(event) => {
                    this._imageViewerRef.current.requestFullscreen();
                }}>
                    Fullscreen
                </button>
                <button onClick={(event) => {
                    const a = document.createElement('a');
                    a.href = currentImage +
                        (currentImage.includes('?') ? '&' : '?') +
                        'download=1';
                    a.download = '';
                    a.target = 'imageDownload';
                    a.click();
                }}>
                    Download
                </button>
                <button
                    disabled={firstPic}
                    onClick={(event) => {
                        this._adjustSelectedDate(0, 0, 0, -1);
                    }}
                >
                    ◀ Pic
                </button>
                <button
                    disabled={lastPic}
                    onClick={(event) => {
                        this._adjustSelectedDate(0, 0, 0, 1);
                    }}
                >
                    ▶ Pic
                </button>
            </div>
            <div className="image-viewer"
                tabIndex={0}
                role="application"
                alt="Zoomable image"
            >
                <div className="image-container">
                    {currentImage && <img
                        ref={this._imageViewerRef}
                        className={"image-viewer"}
                        src={currentImage}
                        /> || 'No image selected'}
                </div>
            </div>
        </Fragment>;
    }

    setTimeIndex(index, refSource = this._timeRefs) {
        const parent = this._timescrollerScrollRef.current;
        const refSourceRef = refSource && refSource[index];
        if (!refSourceRef)
            return false;
        const child = refSourceRef.current;
        const parentRect = parent.getBoundingClientRect();
        const childRect = child.getBoundingClientRect();
        const parentMid = parentRect.top + (parentRect.height / 2);
        const childMid = childRect.top + (childRect.height / 2);
        // If child is off the bottom of the viewport,
        // then childMid > parentMid,
        // and scrollTop needs to be increased
        // (which moves the child up into view)
        const adj = childMid - parentMid;
        parent.scrollTop += adj;
        child.click();
        child.focus();
        return true;
    }

    _wrapClampAndSetSelectedDate(newDate) {
        //
        // Wrap

        if (newDate.getTime() > this.state.today.getTime()) {
            newDate.setFullYear(newDate.getFullYear() - 1);
        }
        if (newDate.getTime() < this.state.minDate.getTime()) {
            newDate.setFullYear(newDate.getFullYear() + 1);
        }

        //
        // Clamp

        if (newDate.getTime() < this.state.minDate.getTime())
            newDate.setTime(this.state.minDate.getTime());
        if (newDate.getTime() > this.state.today.getTime())
            newDate.setTime(this.state.today.getTime());

        //
        // Set

        this._setSelectedDate(newDate);
    }
}

function insertColons(timekey, withSeconds = false) {
    if (!timekey)
        return timekey;
    const hh = timekey.slice(0, 2);
    const mm = timekey.slice(2, 4);
    const ss = timekey.slice(4, 6);
    return `${hh}:${mm}${withSeconds?`:${ss}`:''}`;
}

class Toast extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pinned: new Set()
        };
    }

    static _lastMessageId = 0;

    static addToastToStateOf(component, message, propName = 'messages') {
        const newMessageId = ++this._lastMessageId;
        component.setState((prevState) => {
            const newMap = new Map(prevState[propName] || undefined);
            newMap.set(newMessageId, message);
            return {
                [propName]: newMap
            };
        });
    }

    static makeRemover(component, propName) {
        console.log('Making remover - if you see this frequently',
            'it is probably causing excessive renders,',
            'you need to make one remover and cache it in a class property');
        return function(id) {
            Toast.delMessage(component, id, propName);
        }
    }

    static delMessage(component, id, propName) {
        component.setState((prevState) => {
            const prevMap = prevState[propName];
            if (prevMap) {
                const newMap = new Map(prevMap);
                
                if (newMap.delete(id)) {
                    return {
                        [propName]: newMap
                    };
                }
            }
            
            return undefined;
        });
    }

    _expireTimers = new Map();

    /**
     * 
     * @param {{messages: Map<number, Node>}} prevProps 
     * @param {{}} prevState 
     */
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.messages !== this.props.messages) {
            const added = new Map();
            const deleted = new Map(prevProps.messages);
            for (const [id, message] of this.props.messages) {
                // Not deleted if I saw it
                deleted.delete(id);

                // Added if it isn't in prev
                if (!prevProps.messages.has(id))
                    added.set(id, message);
            }

            for (const [id, _] of deleted)
                this.deleteMessageTimeout(id);

            for (const [id, message] of added)
                this.setMessageTimeout(message, id);
        }
    }

    deleteMessageTimeout(id) {
        const expireTimeout = this._expireTimers.get(id);
        if (expireTimeout !== undefined) {
            clearTimeout(expireTimeout);
            this._expireTimers.delete(id);
        }
    }

    setMessageTimeout(message, id) {
        const expireTimeout = setTimeout((id) => {
            if (this._mounted && this.props.onExpire)
                this.expireMessage(id);
        }, message.duration || this.props.defaultDuration || 5000,
            id);
        this._expireTimers.set(id, expireTimeout);
    }

    expireMessage(id) {
        this.props.onExpire(id);
    }

    componentDidMount() {
        this._mounted = true;
    }

    componentWillUnmount() {
        for (const timeout of this._expireTimers.values())
            clearTimeout(timeout);
        this._expireTimers.clear();
        this._mounted = false;
    }

    render() {
        return this.props.messages.size ? 
        <div className="toast-container">
            {Array.from(this.props.messages.entries())
            .reverse()
            .map(([id, message]) => {
                return <div key={id}
                    onPointerOver={(event) => {
                        this.deleteMessageTimeout(id);
                    }}
                    onPointerOut={(event) => {
                        if (!this.state.pinned.has(id))
                            this.setMessageTimeout(message, id);
                    }}
                    onClick={(event) => {
                        this.togglePinned(id);
                    }}
                    className={"toast-wrapper" +
                        (message.kind === 'error'
                            ? ' toast-error'
                            : message.kind === 'warning'
                            ? ' toast-warning'
                            : message.kind === 'info'
                            ? ' toast-info'
                            : ' toast-error')}
                >
                    {typeof message.content === 'function' 
                        ? message.content()
                        : message.content}
                    <button className="toast-button" title="Copy"
                        onClick={(event) => {
                            event.stopPropagation();
                            event.preventDefault();
                            if (navigator && navigator.clipboard && 
                                navigator.clipboard.writeText
                            ) {
                                navigator.clipboard.writeText(message.text || 
                                    message.content)
                                .then(() => {
                                    console.log('copied');
                                });
                            }
                        }}
                        children={'⧉'}/>
                    <div className="noto top-right"
                        children={this.state.pinned.has(id)
                            ? '📌'
                            : ''}/>
                </div>;
            })}
        </div>
        : null;
    }

    togglePinned(id) {
        this.setState((prevState) => {
            const updated = new Set(prevState.pinned);
            const was = updated.has(id);
            if (was)
                updated.delete(id);

            else
                updated.add(id);
            return {
                pinned: updated
            };
        });
    }
}
